import * as Cesium from 'cesium'
import { TDT_KEY } from '@/config'
/**底图类型 */
export enum BASELAYERS {
  IMG = 'img',
  VEC = 'vec',
  S57 = 'S57',
}
/**底图选择器 */
export class BaselayerSelector {
  viewer
  constructor(viewer: Cesium.Viewer, opt?: { initLayer?: BASELAYERS }) {
    this.viewer = viewer
    const initLayer = opt?.initLayer || BASELAYERS.IMG
    this.setBaseLayer(initLayer)
  }
  /**当前显示的底图 */
  showedLayers: Cesium.ImageryLayer[] = []
  /**设置底图 */
  async setBaseLayer(layer: BASELAYERS) {
    this.removeShowedBaseLayer()
    switch (layer) {
      case BASELAYERS.IMG:
        this.showedLayers.push(
          this.viewer.imageryLayers.addImageryProvider(createProvider('cia'), 0)
        )
        this.showedLayers.push(
          this.viewer.imageryLayers.addImageryProvider(createProvider('img'), 0)
        )
        break
      case BASELAYERS.VEC:
        this.showedLayers.push(
          this.viewer.imageryLayers.addImageryProvider(createProvider('cva'), 0)
        )
        this.showedLayers.push(
          this.viewer.imageryLayers.addImageryProvider(createProvider('vec'), 0)
        )
        break
      case BASELAYERS.S57:
        this.showedLayers.push(
          this.viewer.imageryLayers.addImageryProvider(
            new Cesium.UrlTemplateImageryProvider({
              maximumLevel: 18,
              minimumLevel: 5,
              url: '/jxServer/MSAChartImages/{z}/{y}/{x}.png',
            }),
            0
          )
        )
        break
      default:
        break
    }
  }
  /**移除当前显示的底图 */
  removeShowedBaseLayer() {
    this.showedLayers.forEach((l) => this.viewer.imageryLayers.remove(l))
  }
}
/**创建天地图图层 */
function createProvider(key: 'img' | 'vec' | 'cia' | 'cva') {
  return new Cesium.WebMapTileServiceImageryProvider({
    url: `https://t0.tianditu.gov.cn/${key}_w/wmts?tk=${TDT_KEY}`,
    layer: key,
    style: 'default',
    format: 'tiles',
    tileMatrixSetID: 'w',
    maximumLevel: 18,
    credit: new Cesium.Credit('TianDiTu'),
  })
}
